import type { Plugin } from '@nuxt/types'

export default <Plugin>async function () {
  const subdomain = location.hostname.split('.')[0]
  if (process.env.NODE_ENV === 'development' && subdomain === 'mock') {
    const { mockWorker } = await import('~/mocks/worker')
    await mockWorker.start()
  }
}
